export const DRIVERS = {
  GET_LIST: 'GET_DRVERS_LIST',
  REQUEST_ADD: 'REUEST_ADD_DRIVER',
  ADD: 'ADD_DRIVER',
  UPDATE: 'UPDATE_DRIVER',
  REQUEST_UPDATE: 'REQUEST_UPDATE_DRIVER',
  REQUEST_REMOVE: 'REQUEST_REMOVE_DRIVER',
  REMOVE: 'REMOVE_DRIVER',
}
